import { Locale } from "date-fns";
import { de, enUS, fr } from "date-fns/locale";

import i18n from "@/lib/i18n";

/**
 * Gets the date-fns locale based on the current i18n language.
 * Falls back to German (de) if the language is not supported.
 */
export function getDateFnsLocale(): Locale {
  const language = i18n.language;
  
  switch (language) {
    case "en":
      return enUS;
    case "fr":
      return fr;
    case "de":
    default:
      return de;
  }
}
